
import * as React from 'react';
import { SVG } from '../../utils/types';

const DollarV2: React.FC<SVG> = ({
  width = 28,
  height = 28,
  color = '#9EA7B8',
  otherProps,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...otherProps}
  >
    <path d="M22.2667 10.6667C22.0013 9.91365 21.5166 9.25729 20.875 8.78205C20.2335 8.30681 19.4643 8.03444 18.6667 8H13.3333C12.2725 8 11.2551 8.42143 10.5049 9.17157C9.75476 9.92172 9.33334 10.9391 9.33334 12C9.33334 13.0609 9.75476 14.0783 10.5049 14.8284C11.2551 15.5786 12.2725 16 13.3333 16H18.6667C19.7275 16 20.745 16.4214 21.4951 17.1716C22.2452 17.9217 22.6667 18.9391 22.6667 20C22.6667 21.0609 22.2452 22.0783 21.4951 22.8284C20.745 23.5786 19.7275 24 18.6667 24H13.3333C12.5357 23.9656 11.7665 23.6932 11.125 23.218C10.4834 22.7427 9.99873 22.0863 9.73334 21.3333" stroke="#72011E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 4V8M16 24V28" stroke="#72011E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default DollarV2;